import { createContext, useContext, type PropsWithChildren } from 'react';

const DisabledFieldsContext = createContext<boolean | undefined>(undefined);

export const DisabledFieldsProvider = ({
  value,
  children
}: PropsWithChildren<{
  value?: boolean;
}>) => {
  return <DisabledFieldsContext.Provider value={value}>{children}</DisabledFieldsContext.Provider>;
};

export const useInputsDisabled = () => {
  const context = useContext(DisabledFieldsContext);
  return context;
};
